import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { ORIGIN_ID } from "../shared/index.js";
function isStringArray(value) {
    return (Array.isArray(value) && value.every((item) => typeof item === "string"));
}
function isValidFlagId(value) {
    return typeof value === "string" && value.endsWith(":filters");
}
async function getExperimentUserFiltersByFlag() {
    var _a;
    const filtersByFlag = new Map();
    for (const filter of await ewe.filters.getUserFilters()) {
        if (!filter.metadata || filter.metadata.origin !== ORIGIN_ID) {
            continue;
        }
        const flagId = filter.metadata.flagId;
        if (!isValidFlagId(flagId)) {
            continue;
        }
        const filters = (_a = filtersByFlag.get(flagId)) !== null && _a !== void 0 ? _a : new Set();
        filters.add(filter.text);
        filtersByFlag.set(flagId, filters);
    }
    return filtersByFlag;
}
async function getExperimentFiltersByFlag() {
    const flags = await ewe.experiments.getFlags();
    const filtersByFlag = new Map();
    for (const [flagId, value] of Object.entries(flags)) {
        if (!isValidFlagId(flagId)) {
            continue;
        }
        if (isStringArray(value) && value.length > 0) {
            const filtersSet = new Set();
            const uniqueFilters = [];
            for (const filter of value) {
                if (filtersSet.has(filter)) {
                    console.warn(`Duplicate filter "${filter}" in experiment config for flag "${flagId}"`);
                    continue;
                }
                filtersSet.add(filter);
                uniqueFilters.push(filter);
            }
            filtersByFlag.set(flagId, uniqueFilters);
        }
    }
    return filtersByFlag;
}
export async function syncFilters() {
    var _a;
    const currentByFlag = await getExperimentUserFiltersByFlag();
    const desiredByFlag = await getExperimentFiltersByFlag();
    const filtersToRemove = [];
    for (const [flagId, currentFilters] of currentByFlag) {
        const desiredFilters = desiredByFlag.get(flagId);
        for (const filter of currentFilters) {
            if (!(desiredFilters === null || desiredFilters === void 0 ? void 0 : desiredFilters.includes(filter))) {
                filtersToRemove.push(filter);
            }
        }
    }
    if (filtersToRemove.length > 0) {
        await ewe.filters.remove(filtersToRemove);
    }
    for (const [flagId, desiredFilters] of desiredByFlag) {
        const currentFilters = (_a = currentByFlag.get(flagId)) !== null && _a !== void 0 ? _a : new Set();
        const filtersToAdd = [];
        for (const filter of desiredFilters) {
            if (currentFilters.has(filter)) {
                continue;
            }
            const error = ewe.filters.validate(filter);
            if (error) {
                console.warn(`Skipping invalid experiment filter "${filter}":`, error);
                continue;
            }
            filtersToAdd.push(filter);
        }
        if (filtersToAdd.length === 0) {
            continue;
        }
        await ewe.filters.add(filtersToAdd, {
            origin: ORIGIN_ID,
            flagId,
        });
    }
}
